import { useEffect, useRef, useState, useCallback } from "react";
import "@/App.css";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Collection from "@/components/Collection";
import Bento from "@/components/Bento";
import Commission from "@/components/Commission";
import MeetElla from "@/components/MeetElla";
import PaletteBand from "@/components/PaletteBand";
import ImagineStation from "@/components/ImagineStation";
import OrderSection from "@/components/OrderSection";
import Footer from "@/components/Footer";
import Petals from "@/components/Petals";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  const lenisRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [intent, setIntent] = useState("");
  const [customSpec, setCustomSpec] = useState("");

  const scrollTo = useCallback((target) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target, { offset: -72, duration: 1.4 });
    }
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    axios
      .get(`${API}/products`)
      .then((r) => setProducts(r.data))
      .catch(() => {});
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const orderProduct = useCallback(
    (name) => {
      setIntent(name);
      scrollTo("#order");
    },
    [scrollTo]
  );

  const sendDream = useCallback(
    (spec) => {
      setIntent("Something fully custom");
      setCustomSpec(spec);
      scrollTo("#order");
    },
    [scrollTo]
  );

  return (
    <div className="relative bg-cream text-ink font-sans min-h-screen overflow-x-clip">
      <div className="grain-overlay" aria-hidden="true" />
      <Petals />
      <div className="relative z-10">
        <Nav onNavigate={scrollTo} />
        <main>
          <Hero onNavigate={scrollTo} />
          <Marquee />
          <Collection products={products} onOrder={orderProduct} />
          <PaletteBand />
          <Bento />
          <Commission />
          <ImagineStation onDream={sendDream} />
          <MeetElla onNavigate={scrollTo} />
          <OrderSection products={products} intent={intent} customSpec={customSpec} onIntentChange={setIntent} />
        </main>
        <Footer onNavigate={scrollTo} />
      </div>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
